import type { ReactNode } from 'react'

import { SwitchInput, type TSwitchInputProps } from '@/src/elements/switchInput'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

export const SettingsCardSwitchInput: Record<'Mail' | 'Push', (props: TSwitchInputProps) => ReactNode> = {
  Mail: (props) => {
    const { t } = useTranslate()
    return (
      <SwitchInput
        label={t('settings.card.notifs.email')}
        testID={TEST_ID.SETTINGS.COMPONENTS.CARD_GENERAL_SWITCH_INPUT.MAIL}
        icon={ICON.MAIL}
        {...props}
      />
    )
  },
  Push: (props) => {
    const { t } = useTranslate()
    return (
      <SwitchInput
        label={t('settings.card.notifs.push')}
        testID={TEST_ID.SETTINGS.COMPONENTS.CARD_GENERAL_SWITCH_INPUT.PUSH}
        icon={ICON.DEVICES}
        {...props}
      />
    )
  },
}
